<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <module-content *ngIf="!is401 && !is404"
                    [title]="viewedTeamName">
        <div *ngIf="dataSource.count === 0" class="legend">{{ 'No_athlete_yet' | translate }}</div>
        <div *ngIf="membersNumber > 0" class="memberNumber">
            {{ 'n_members' | translate:{n: membersNumber} }}
        </div>
        <div *ngIf="teamDescription.length > 0" class="teamDescription">
            {{ teamDescription }}
        </div>
        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort
                   (matSortChange)="onSortChange($event)">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef class="image-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="image-cell">
                    <img *ngIf="row.user.avatar"
                         [src]="conf.storageRootUrl + row.user.avatar" />
                    <mat-icon *ngIf="!row.user.avatar">
                        account_circle
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="athlete">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Athlete_Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div *ngIf="row.rights.view; else notLink">
                        <a (click)="onDisplayAthleteClicked(row)">{{ row.user.firstName + ' ' + row.user.lastName }}</a>
                    </div>
                    <ng-template #notLink>
                        <div>{{ row.user.firstName + ' ' + row.user.lastName }}</div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="coach">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Athlete_Trainer' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.athlete.externalCoachName }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="special-actions-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">
                    <div class="hideable-500">
                        <!--<button mat-icon-button
                                [disabled]="!row.rights.changeTeams"
                                [matTooltip]="'Delete' | translate"
                                (click)="onRemoveAthleteFromTeamClicked(row)"
                                disabled="true">
                            <mat-icon>delete_outlined</mat-icon>
                        </button>-->
                    </div>
                    <div class="visible-500">
                        <button mat-icon-button
                                [matMenuTriggerFor]="rowMoreMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                            <!--<button mat-menu-item
                                    [disabled]="!row.rights.changeTeams"
                                    (click)="onRemoveAthleteFromTeamClicked(row)"
                                    disabled="true">
                                <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
                            </button>-->
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

        </mat-table>
        <mat-paginator [class.hidden]="dataSource.count == 0"
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons>
        </mat-paginator>
    </module-content>
    <main-action *ngIf="!is401 && !is404 && isEditable"
                 [title]="'Edit_team' | translate"
                 [icon]="'edit'"
                 (onAction)="onModifyTeamClicked(viewedTeam)">
    </main-action>
</page-content>
